// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qSetViewTable {
  width: 100%;
  overflow-y: auto;
  border-spacing: 0px;
  max-height: 400px;
  /* border: 1px solid #797979; */
  border-collapse: collapse;
  /* font-weight: 500; */
}

.qSetViewTable tbody tr:hover {
  background-color: #cae0ee;
}

.qSetViewTable tbody tr:active {
  background-color: #71b9e9 !important;
}
.qSetViewTable tbody tr:visited {
  background-color: #71b9e9 !important;
}

.qSetViewTable tbody tr td {
  text-align: center;
  padding: 10px;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  cursor: pointer;
}

.qSetViewTable thead tr th {
  text-align: center;
  position: sticky !important;
  top: 0;
  background-color: #e5e5e5;
  color: #797979;
  padding: 15px 2px;
  /* width: 102px; */
}

.qSetViewTable th {
  border-bottom: 1px solid #797979;
  /* border-collapse: collapse; */
  font-weight: 700;
}

.qSetViewTable td {
  border-bottom: 1px solid #797979;
  /* border-collapse: collapse; */
  /* font-weight: 500; */
}

.qSetViewTable td:nth-child(3) {
  width: 120px;
}

.qSetViewTable td:nth-child(4) {
  width: 225px;
}

.selQSet {
  background-color: #cae0ee;
}

::-webkit-scrollbar {
  position: absolute;
  width: 12px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #dcdcdc;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 5px;
}

.editQSet {
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 4px 8px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 3px;
}

.deleteQSet {
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 4px 8px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 15px;
  margin-top: 3px;
}

.QSetViewTableContainer {
  height: 400px;
  margin: 0 3%;
  margin-bottom: 20px;
  overflow-y: auto;
  width: 92%;
}

.QSetTablePagination {
  min-width: 62%;
}

.qSetViewQuestiondiv {
  max-height: 500px;
  overflow: auto;
  margin-bottom: 20px;
}

.popUpBack {
  position: fixed; /* Positioning and size */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 2;
}

.noPopUp {
  display: none;
}

.yesPopUp {
  position: fixed;
  top: 40%;
  left: 46%;
  width: 300px !important;
  margin-left: -100px;
  height: 150px;
  margin-top: -25px;
  background: white;
  /* border: solid 3px #d7d3d3; */
  z-index: 1;
  border-radius: 8px;
}

.popUpCloseBtn {
  position: relative;
  left: 270px;
  top: 1px;
  border: none;
  background-color: white;
  padding-right: 1px;
}

.closeIcon {
  font-size: 21px !important;
  color: gray;
}

.popUpCloseBtn:active {
  position: relative;
  left: 278px;
  top: 1px;
  border: none;
  background-color: rgb(189, 187, 187);
  font-weight: 700;
}

.warningDiv {
  display: flex;
  justify-content: center;
  margin-top: -17px;
}

.warningIcon {
  color: orange;
  font-size: 45px !important;
}

.popUph2 {
  display: flex;
  justify-content: center;
  margin-top: 0px;
  margin-bottom: 20px;
}

.popUpButtonDiv {
  display: flex;
  justify-content: center;
}

.popUpOkButton {
  color: #f6f8f7;
  background: #68dff0;
  text-transform: capitalize;
  padding: 6px 15px 6px 15px;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  border: none;
  height: 46px;
  width: 50%;
  border-radius: 0 0 5px 0;
}

.popUpOkButton:active {
  color: #f6f8f7;
  background: #50bbcc;
  text-transform: capitalize;
  padding: 6px 15px 6px 15px;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  border: none;
  height: 46px;
  width: 50%;
  border-radius: 0 0 5px 0;
}

.popUpCancelButton {
  color: white;
  background: grey;
  text-transform: capitalize;
  padding: 6px 15px 6px 15px;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  border: none;
  height: 46px;
  width: 50%;
  border-radius: 0 0 0 5px;
}

.popUpCancelButton:active {
  color: white;
  background: rgb(182, 181, 181);
  text-transform: capitalize;
  padding: 6px 15px 6px 15px;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  border: none;
  height: 46px;
  width: 50%;
  border-radius: 0 0 0 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/QSetView/qSetView.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,MAAM;EACN,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,yBAAyB;EAC1C,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":[".qSetViewTable {\n  width: 100%;\n  overflow-y: auto;\n  border-spacing: 0px;\n  max-height: 400px;\n  /* border: 1px solid #797979; */\n  border-collapse: collapse;\n  /* font-weight: 500; */\n}\n\n.qSetViewTable tbody tr:hover {\n  background-color: #cae0ee;\n}\n\n.qSetViewTable tbody tr:active {\n  background-color: #71b9e9 !important;\n}\n.qSetViewTable tbody tr:visited {\n  background-color: #71b9e9 !important;\n}\n\n.qSetViewTable tbody tr td {\n  text-align: center;\n  padding: 10px;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.qSetViewTable thead tr th {\n  text-align: center;\n  position: sticky !important;\n  top: 0;\n  background-color: #e5e5e5;\n  color: #797979;\n  padding: 15px 2px;\n  /* width: 102px; */\n}\n\n.qSetViewTable th {\n  border-bottom: 1px solid #797979;\n  /* border-collapse: collapse; */\n  font-weight: 700;\n}\n\n.qSetViewTable td {\n  border-bottom: 1px solid #797979;\n  /* border-collapse: collapse; */\n  /* font-weight: 500; */\n}\n\n.qSetViewTable td:nth-child(3) {\n  width: 120px;\n}\n\n.qSetViewTable td:nth-child(4) {\n  width: 225px;\n}\n\n.selQSet {\n  background-color: #cae0ee;\n}\n\n::-webkit-scrollbar {\n  position: absolute;\n  width: 12px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #dcdcdc;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #bdbdbd;\n  border-radius: 5px;\n}\n\n.editQSet {\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 4px 8px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 3px;\n}\n\n.deleteQSet {\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 4px 8px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 15px;\n  margin-top: 3px;\n}\n\n.QSetViewTableContainer {\n  height: 400px;\n  margin: 0 3%;\n  margin-bottom: 20px;\n  overflow-y: auto;\n  width: 92%;\n}\n\n.QSetTablePagination {\n  min-width: 62%;\n}\n\n.qSetViewQuestiondiv {\n  max-height: 500px;\n  overflow: auto;\n  margin-bottom: 20px;\n}\n\n.popUpBack {\n  position: fixed; /* Positioning and size */\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(128, 128, 128, 0.5);\n  z-index: 2;\n}\n\n.noPopUp {\n  display: none;\n}\n\n.yesPopUp {\n  position: fixed;\n  top: 40%;\n  left: 46%;\n  width: 300px !important;\n  margin-left: -100px;\n  height: 150px;\n  margin-top: -25px;\n  background: white;\n  /* border: solid 3px #d7d3d3; */\n  z-index: 1;\n  border-radius: 8px;\n}\n\n.popUpCloseBtn {\n  position: relative;\n  left: 270px;\n  top: 1px;\n  border: none;\n  background-color: white;\n  padding-right: 1px;\n}\n\n.closeIcon {\n  font-size: 21px !important;\n  color: gray;\n}\n\n.popUpCloseBtn:active {\n  position: relative;\n  left: 278px;\n  top: 1px;\n  border: none;\n  background-color: rgb(189, 187, 187);\n  font-weight: 700;\n}\n\n.warningDiv {\n  display: flex;\n  justify-content: center;\n  margin-top: -17px;\n}\n\n.warningIcon {\n  color: orange;\n  font-size: 45px !important;\n}\n\n.popUph2 {\n  display: flex;\n  justify-content: center;\n  margin-top: 0px;\n  margin-bottom: 20px;\n}\n\n.popUpButtonDiv {\n  display: flex;\n  justify-content: center;\n}\n\n.popUpOkButton {\n  color: #f6f8f7;\n  background: #68dff0;\n  text-transform: capitalize;\n  padding: 6px 15px 6px 15px;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  border: none;\n  height: 46px;\n  width: 50%;\n  border-radius: 0 0 5px 0;\n}\n\n.popUpOkButton:active {\n  color: #f6f8f7;\n  background: #50bbcc;\n  text-transform: capitalize;\n  padding: 6px 15px 6px 15px;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  border: none;\n  height: 46px;\n  width: 50%;\n  border-radius: 0 0 5px 0;\n}\n\n.popUpCancelButton {\n  color: white;\n  background: grey;\n  text-transform: capitalize;\n  padding: 6px 15px 6px 15px;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  border: none;\n  height: 46px;\n  width: 50%;\n  border-radius: 0 0 0 5px;\n}\n\n.popUpCancelButton:active {\n  color: white;\n  background: rgb(182, 181, 181);\n  text-transform: capitalize;\n  padding: 6px 15px 6px 15px;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  border: none;\n  height: 46px;\n  width: 50%;\n  border-radius: 0 0 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
